import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHRBackend from 'i18next-xhr-backend';
import { reactI18nextModule } from 'react-i18next';
import numbro from 'numbro';
import dateFormat from 'date-fns/format';

import { setLanguage } from 'store/language/actions';
import store from 'store';

i18next
  .use(LanguageDetector)
  .use(XHRBackend)
  .use(reactI18nextModule)
  .init({
    debug: true,
    whitelist: ['en', 'fi'],
    fallbackLng: 'en',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    ns: 'translation',
    defaultNS: 'translation',
    interpolation: {
      format: (value, format) => {
        switch (format) {
          case 'date':
            return dateFormat(value, 'DD.MM.YYYY');
          case 'time':
            return dateFormat(value, 'HH:mm');
          case 'duration':
            return numbro(value).format('0[.]0[0]');
          default:
            return value;
        }
      }
    },
    react: {
      wait: true
    }
  });

i18next.on('initialized', () => {
  store.dispatch(setLanguage(i18next.language));
});

i18next.on('languageChanged', language => {
  const cultureCode = language === 'fi' ? 'fi-FI' : 'en-GB';

  numbro.culture(cultureCode, require(`numbro/languages/${cultureCode}`));
  numbro.setCulture(cultureCode);
});

export default i18next;



// WEBPACK FOOTER //
// ./src/i18n.js